// import React from 'react'

import img1 from "../../media/images/GurugramContent1.jpg";
import img2 from "../../media/images/GurugramContent2.jpg";

const LocationContentGreaterNoida = () => {
  return (
    <div>
      <div className="location-content">
        <div className="location-content-main">
          <div className="location-content-main-img">
            <img src={img1} title="Pet Groomers Near Me" alt="offer-imh" />
          </div>

          <div className="location-content-section">
            <h3 className="location-content-heading">

              🐾 Premium <span>Pet Grooming</span> at Home in <span>Greater Noida</span> | FluffyTouch
              
              </h3>
            <div className="location-content-text">
           "Serving Alpha 1 to Delta 1 - Because Your Pet Deserves the Best!"
           📞 One-Tap Booking: 96581 89189 | 🌍 Coverage: All Sectors, Villas & Farmhouses
            </div>

            <div className="location-content-image">
              <img src={img2} title="Pet Groomers Near Me" alt="offer-imh" />
            </div>

            <section>
              <div className="location-content-sub-heading">
              Why Greater Noida Pet Parents Choose Us?
              </div>
              <div className="location-content-text">
      
      <b>✅ Zero Travel Stress –</b> No more long drives to Noida salons
<br /><b>✅ Monsoon-Ready –</b> Special anti-tick treatments for the rainy season
<br /><b>✅ Breed Experts –</b> From indie street dogs to exotic Persians
<br /><b>✅ Farmhouse Friendly –</b> Mobile grooming vans for rural properties
                
              </div>

              <div className="location-content-sub-heading">
             Areas We Serve
              </div>
              <div className="location-content-text">
                
               📍 Residential: Alpha, Beta, Gamma, Delta sectors
<br />📍 Educational Hub: Near Universities
<br />📍 Commercial: Knowledge Park, Tech Zone
<br />📍 Rural: Surrounding villages
<br />(Call to confirm exact location coverage!)

                
              </div>

              <div className="location-content-sub-heading">
                How to Book? (2 Minutes Flat!)
              </div>
              <div className="location-content-text">
           <ol>
              <li>WhatsApp "GREATER" to 96581 89189</li>
              <li>Get instant slot confirmation</li>
              <li>Enjoy ₹300 OFF first booking (Use code GN2024)</li>
           </ol>
              </div>

     

              <div className="location-content-sub-heading">
                Real Greater Noida Reviews
                
              </div>
              <div className="location-content-text">
                
"Finally found groomers who come to our Alpha 2 farmhouse!" - The Oberoi Family
<br /> "My Persian cat's mats gone without stress in Beta 1!" - Dr. Sharma, Professor

               
              </div>

              <div className="location-content-sub-heading">
              Greater Noida Pro Tips
              </div>
              <div className="location-content-text">
                
              ⚠️ Best Time to Book: Weekday mornings (avoid student rush hours)
<br />🌧️ Monsoon Alert: Book flea treatments in advance (June-Sept)
<br />🎓 Student Discount: 10% OFF for university pet parents

                
              </div>
            </section>

           

            <div className="location-content-sub-heading">Why We're Different?</div>
            <div className="location-content-text">
              ✔ Local Knowledge: Shortcuts around Pari Chowk traffic
<br />✔ Campus Specialists: Handle hostel pets gently
<br />✔ Rural Experience: Comfortable with farm animals too
<br />📲 Call Now: 96581 89189 | 💬 WhatsApp: Send pet photos for quick quotes        
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationContentGreaterNoida;
